<app-img-header
  title="Región / DRM"
  alt="Catálogo Región DRM"
  image="/assets/images/catalogos/intro.jpg"
  [contentTemplate]="template"
>
</app-img-header>
<app-preloader *ngIf="isLoading"></app-preloader>
<app-notifications></app-notifications>

<main class="main">
  <div id="detail">
    <div class="pageWidth">
      <div class="actionsWrapper">
        <button class="tertiary" (click)="openCreate()"><i class="icon"></i> Nueva referencia</button>
      </div>

      <div *ngIf="data.length === 0 && !isLoading" class="noData">No hay información disponible</div>

      <div class="customTable regionDrm" *ngIf="data.length > 0">
        <div class="header">
          <div class="cell region">Región / Zona</div>
          <div class="cell unidad">Unidad de negocio</div>
          <div class="cell drm">Gerente de ventas (DRM)</div>
          <div class="cell sucursales">Sucursales</div>
          <div class="cell habilitado">Habilitado</div>
          <div class="cell acciones"></div>
        </div>

        <div class="row" *ngFor="let item of data">
          <div class="cell region">{{ item.regionName }}</div>
          <div class="cell unidad">{{ segmentLabel(item.segment) }}</div>
          <div class="cell drm">{{ item.drmUserName || '—' }}</div>
          <div class="cell sucursales">{{ item.branchCount }}</div>
          <div class="cell habilitado">
            <img
              *ngIf="item.enabled === true"
              src="/assets/images/icons/notification_success.svg"
              alt="Sí"
              class="available"
              tp="Habilitada"
            />
            <img
              *ngIf="item.enabled === false"
              src="/assets/images/icons/notification_error.svg"
              alt="No"
              class="notAvailable"
              tp="Deshabilitada"
            />
          </div>
          <div class="cell acciones">
            <a class="edit" tp="Editar" (click)="openEdit(item)">Editar</a>
            <a class="delete" tp="Eliminar" (click)="openDeleteConfirm(item)">Eliminar</a>
          </div>
        </div>
      </div>

      <div class="actionsWrapper" *ngIf="data.length > 0">
        <button class="tertiary" (click)="openCreate()"><i class="icon"></i> Nueva referencia</button>
      </div>
    </div>
  </div>
</main>

<ng-template #modalForm>
  <app-region-drm-form-modal
    [isEdit]="isEditModal"
    [catalogId]="editingId"
    [openKey]="modalOpenKey"
    (saved)="onSaved()"
  ></app-region-drm-form-modal>
</ng-template>

<ng-template #templateConfirmation>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="confirmDelete()"
  ></app-template-confirmation>
</ng-template>

<ng-template #template>
  <div class="wrapperG3">
    <div>
      <label>Región / Zona</label>
      <app-input [data]="searchRegion" (textSearch)="filterRegion($event)" [resetInput]="reset"></app-input>
    </div>
    <div>
      <label>Unidad de negocio</label>
      <app-select
        [options]="segmentOptions"
        placeholder="Todas"
        key="label"
        [resetSelect]="reset"
        (optionSelected)="filterSegment($event)"
      ></app-select>
    </div>
  </div>
  <div class="filtersActions">
    <button class="primary" (click)="search()">Buscar</button>
    <button class="secondary" (click)="resetFilters()">Limpiar filtros</button>
  </div>
</ng-template>
